<template>
  <div class="jIndexFlows">
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="title-tab-experience-manager">WORKFLOW MANAGER</div>
      <div class="d-flex m__t--42">
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'flow'}"
          class="tab-experience-manager m__r--35"
          @click="selectTab('flow')">
          FLOW
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'flow_sla'}"
          class="tab-experience-manager m__r--35"
          @click="selectTab('flow_sla')">
          FLOW SLA
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'rules'}"
          class="tab-experience-manager"
          @click="selectTab('rules')">
          RULES
        </div>
      </div>
    </div>

    <div class="studio-page-content">
      <jFlowIndex v-if="tabSelected === 'flow'" />
      <jFlowSLA v-if="tabSelected === 'flow_sla'" />
      <div v-if="tabSelected === 'rules'">
        <j-rules
          ref="rules"
          @row-click="rulesRowClick"
          @pagination="hideFloatingPrompt"/>

        <jRulesFloatingPrompt
          v-if="rules"
          ref="rulesFloating"
          :rules="rules"
          class="rulesfloating"
          @hideFloatingPrompt="hideFloatingPrompt"
          @deleteRules="deleteRules"/>
      </div>

      <!-- space after floating prompt appear -->
      <div>
        <div
          class="space-floating"/>
      </div>
    </div>
  </div>
</template>

<script>
// import jFlowGlobal from '@/views/flow-rule/flow/jFlowGlobal';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jFlowIndex from '@/views/flow-rule/flow/flow-non-sla/jFlowIndex';
import jFlowSLA from '@/views/flow-rule/flow/flow-sla/jFlowSLA';
import { mapActions, mapState } from 'vuex';
import jFlow from './flow/jFlow';
import jRules from './rules/jRules';
import jFlowFloatingPrompt from './flow/jFlowFloatingPrompt';
import jRulesFloatingPrompt from './rules/jRulesFloatingPrompt';

export default {
  name: 'Index',
  components: {
    jFlow,
    jRules,
    jFlowFloatingPrompt,
    jRulesFloatingPrompt,
    jLoadingTable,
    // jFlowGlobal,
    jFlowIndex,
    jFlowSLA,
  },
  data() {
    return {
      flow: null,
      rules: null,
      tabSelected: 'flow',
    };
  },
  computed: {
    ...mapState('jStoreFlows', ['flows_table', 'is_flow_deleted', 'manage_sla', 'manage_flow']),
    ...mapState('jStoreRules', ['rules_table', 'is_rules_deleted']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    flow_id() {
      if (this.flow) {
        return this.flow.id;
      }
      return null;
    },
    rules_id() {
      if (this.rules) {
        return this.rules.id;
      }
      return null;
    },

    // eslint-disable-next-line
    'manage_sla.is_open': function() {
      this.hideFloatingPrompt();
    },
  },
  watch: {
    // is_flow_deleted() {
    //   if (this.is_flow_deleted) {
    //     this.$refs.flow.refreshTable();
    //     this.$store.commit('jFlows/flowDeleted');
    //   }
    // },
    is_rules_deleted() {
      if (this.is_rules_deleted) {
        this.$refs.rules.refreshTable();
        this.$store.commit('jStoreRules/rulesDeleted');
      }
    },

    // eslint-disable-next-line
    // 'manage_sla.is_open': function() {
    //   this.hideFloatingPrompt();
    // },

    // eslint-disable-next-line
    'manage_flow.data': function(newData) {
      if (newData !== null) {
        this.flowRowClick(newData);
      } else {
        this.flow = null;
      }
      // this.hideFloatingPrompt();
    },
  },
  created() {
    // this.getListFlow();
    // this.getListRules();
  },
  methods: {
    ...mapActions('jStoreFlows', ['removeFlow', 'getListFlow']),
    ...mapActions('jStoreRules', ['removeRules', 'getListRules']),

    selectTab(tab) {
      this.tabSelected = tab;
    },
    flowRowClick(data) {
      this.flow = data.row;
      this.flow.flow_type = 1;
      if (this.rules) {
        this.$refs.rules.removeRowClick(this.rules_id);
      }
      this.rules = null;
    },
    rulesRowClick(data) {
      this.rules = data.row;
      // if (this.flow) {
      //   this.$refs.flow.removeRowClick(this.flow_id);
      // }
      this.flow = null;
      this.$store.commit('jStoreFlows/setFlowData', null);
    },

    hideFloatingPrompt() {
      if (this.flow) {
        if (this.flow_id) {
          this.$refs.flow.removeRowClick(this.flow_id);
          setTimeout(() => {
            this.flow = null;
            this.$store.commit('jStoreFlows/setFlowData', null);
          }, 200);
        }
        setTimeout(() => {
          this.flow = null;
          this.$store.commit('jStoreFlows/setFlowData', null);
        }, 200);
      } else {
        if (this.rules_id) {
          this.$refs.rules.removeRowClick(this.rules_id);
          setTimeout(() => {
            this.rules = null;
          }, 200);
        }
        setTimeout(() => {
          this.rules = null;
        }, 200);
      }
    },

    // deleteFlow() {
    //   const deleteFlow = {
    //     id: this.flow_id,
    //   };
    //   this.removeFlow(deleteFlow);
    //   // this.$refs.flow.refreshTable();
    //   this.hideFloatingPrompt();
    // },
    deleteRules() {
      const deleteRules = {
        id: this.rules_id,
      };
      // this.$refs.rules.refreshTable();
      this.removeRules(deleteRules);
      this.hideFloatingPrompt();
    },
  },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/flow-rule/index.vue